/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer, fourDecimalRenderer } from '../../../../SharedModules/utilities/utilities';


function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
// quarter sorting
export const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

// grid on first Scren
export const ManufactureTableHead = [
  {
    headerName: 'Select All',
    maxWidth: 135,
    headerCheckboxSelection: true, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    checkboxSelection: true,
    pdfExportOptions: {
      skipColumn: true,
    },
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    columnSpan: 3,
    minWidth: Styles.Width_300,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const DisputeCodesSelected = [
  {
    headerName: 'Select All',
    maxWidth: 135,
    headerCheckboxSelection: true, // For header check box
    filter: false,
    resizable: true,
    field: 'checkSelect',
    editable: false,
    suppressMenu: true,
    sortable: false,
    pdfExportOptions: {
      skipColumn: true,
    },
    checkboxSelection: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
  },
  {
    headerName: 'Code',
    field: 'codeValuetemp',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    maxWidth: 135,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Short Desc',
    field: 'shortDescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Long Desc',
    field: 'longDescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_300,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

// Display Screen Grid
export const DisputeCodesDisplay = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    columnSpan: 3,
    minWidth: Styles.Width_240,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Quarter',
    field: 'targetQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    comparator: comparatorQtr,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    excelAlignment: 'right',
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    // cellRenderer: cellRenderer,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Payment URA',
    field: 'mostRecentUra',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Current Units Billed',
    field: 'noOfUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    cellRenderer: fourDecimalRenderer,
    comparator: amountComparator,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Units Paid to Date',
    field: 'paidUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    isTextColorRed: true,
    cellRenderer: fourDecimalRenderer,
    comparator: amountComparator,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Current Amount Due',
    field: 'currentAmtDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,

    isAmount: true,
    printPrefixValue: '$',
    alignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount Paid',
    field: 'paidAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_125,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    cellRenderer: cellRenderer,
    comparator: amountComparator,
    printPrefixValue: '$',
    isAmount: true,
    alignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Balance Due',
    field: 'balanceDue',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    isAmount: true,
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    comparator: amountComparator,
    alignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
